import React, {Component} from 'react'
import styles from './Button.css'

export default class Button extends Component {
  render () {
    return (
      <div className={styles.cont +' '+ (styles[this.props.theme] || styles.default)}>
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Rist/modules/Button/index.js